const maxWords = 5

export function mergeStrings(strings: string[]) {
  if (strings.length === 1) return strings[0]
  const words = strings.map((str) => str.split(/(\w+)/))
  const result: string[] = []
  while (words[0].length) {
    const word = words[0][0]
    if (words.every((w) => w[0] === word)) {
      result.push(word)
      for (const w of words) w.shift()
    } else {
      const term = words[0].find((word, i) => {
        if (!i || i > maxWords || !word.trim()) return false
        return words.every((ws) =>
          ws.some((w, i) => i > 0 && i <= maxWords && w === word)
        )
      })
      const opts = new Set<string>()
      if (term) {
        for (const w of words) {
          let pos = w.indexOf(term)
          while (pos > 0 && !w[pos - 1].trim()) pos -= 1
          opts.add(w.splice(0, pos).join(''))
        }
      } else {
        if (words[0].length > maxWords) return strings[0]
        for (const w of words) {
          opts.add(w.splice(0).join(''))
        }
      }
      result.push(`(${[...opts].sort().join('-')})`)
    }
  }
  return result.join('')
}
